import React, { useState } from "react";
import SolidButton from "@/components/ui/Buttons/SolidButton";
import ChatConfirmationModal from "@/components/messages-comps/chat-room-by-id/chat-confirmation-modal";
import Modal from "@/components/ui/modal";
import { useTranslations } from "@/lib/static-intl";

const UserUnfollowBtn = ({
  children,
  className = "",
  loader = false,
  disabled = false,
  onClick,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOkHandler = () => {
    onClick?.();
    setIsOpen(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "black",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const userProfileT = useTranslations("user_profile");

  return (
    <>
      {<div onClick={() => setIsOpen(true)}>{children}</div>}

      {!children && (
        <SolidButton
          className={className}
          loading={loader}
          disabled={disabled}
          onClick={() => setIsOpen(true)}
        >
          {userProfileT("following")}
        </SolidButton>
      )}

      {/* <Modal
                open={isOpen}
                onClose={() => setIsOpen(false)}
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" className='mb-4'>
                        Are you sure you want to unfollow this user
                    </Typography>
                    <ChatConfirmationModal
                        onOkText="Unfollow"
                        onCancel={() => setIsOpen(false)}
                        onOk={onOkHandler}
                    />
                </Box>
            </Modal> */}

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={userProfileT("user_unfollow_warning_modal_title")}
      >
        <ChatConfirmationModal
          onOkText={userProfileT("unfollow")}
          onCancel={() => setIsOpen(false)}
          onOk={onOkHandler}
        />
      </Modal>
    </>
  );
};

export default UserUnfollowBtn;
